import { Modal, ModalHeader, ModalBody, Button } from 'reactstrap';
import { useEffect, useState } from 'react';
import { useUserQuestionnairesScheduled } from "../../hooks/useUserQuestionnaires";
import { LocalStorageScheduledDateName } from "../../helper/constants";
import QuestionnaireQuestionBlock from "../../components/ContentManagement/QuestionnaireQuestionBlock";
import { IUserQuestionnaireQuestionWithAnswer, UserFeedbackAnswer } from '../../interfaces/contentManagement/UserQuestionnaireWithAnswerOptions';
import { useMutation } from '@apollo/client';
import toast from 'react-hot-toast';
import { addUserQuestionnairesFeedbacks } from '../../graphql/content-management/addUserQuestionnairesFeedbacks';


export default function QuestionnaireScheduledModal() {

    const [isOpen, setIsOpen] = useState<boolean>(false);
    const [showQuestions, setShowQuestions] = useState<boolean>(false);
    const [isOnProcess, setIsOnProcess] = useState<boolean>(false);
    const [questionnaire, setQuestionnaire] = useState<IUserQuestionnaireQuestionWithAnswer>(null);
    const [userAnswer, setUserAnswers] = useState<UserFeedbackAnswer[]>([]);

    const [addUserQuestionnairesFeedbacksHook] = useMutation(addUserQuestionnairesFeedbacks,{
        onCompleted : () =>{
            toast.success("Thanks for your feedback! We truly appreciate your input.");
        },
        onError : () =>{
            toast.error("Something went wrong whilst accepting your feedback . Please try again or if issue persists, please contact us");
        }
    });
    
    const { data } = useUserQuestionnairesScheduled();

    const Proceed = () => {
        setShowQuestions(true);
    }

    const HandleAnswerLater  = () => {
        SetToAnswerNextDay();
        setIsOpen(false);
    }

    const SetToAnswerNextDay = () => {
        // 1 Day
        let result = new Date();
        result.setDate(result.getDate() + 1);
        //Use local storage 
        window.localStorage.setItem(LocalStorageScheduledDateName, result.toString());
    }

    const HandleChange = (answers : UserFeedbackAnswer[]) => {
        setUserAnswers(answers);
    }
    
    const HandleConfirm = async () => {

        setIsOnProcess(true);

        const isAdded = await addUserQuestionnairesFeedbacksHook({
            variables : {
                record : {
                    questionnaire_id : questionnaire._id,
                    answers : userAnswer
                }
            }
        });

        if(!isAdded) {
            setIsOnProcess(false);
            return;
        }
        setIsOnProcess(false);
        setIsOpen(false);
        SetToAnswerNextDay();

    }

    useEffect(() => {
        if(data) {
            if(data.user_questionnaire_scheduled) {
                const getDismissDate = window.localStorage.getItem(LocalStorageScheduledDateName);
                if(getDismissDate) { 
                    if(new Date() < new Date(getDismissDate)) {
                        SetToAnswerNextDay();
                        return;
                    }
                }
                setIsOpen(true);
                setQuestionnaire(data.user_questionnaire_scheduled);
            } 
            else {
                SetToAnswerNextDay();
            }
            
            
        } 
        
    },[data]);

    return (
    <Modal
        isOpen={isOpen}
        backdrop={true}
        size={showQuestions ? "xl" : ""}
    >
        <ModalHeader
            className="pb-0"
        >
            <p className="text-lg font-weight-bold">{!showQuestions ? "Hello again!" : questionnaire?.name}</p>
        </ModalHeader>
        <ModalBody className="pt-0">
            {
                !showQuestions ?
                    <div>
                        <small className="">
                            Thank you for using desk.coach! Can you take a moment to answer a few quick questions? It'll help us improve your experience!
                        </small>
                        <div className="d-flex justify-content-between mb-3 mt-5">
                            
                            <Button onClick={HandleAnswerLater}>Answer Later</Button>
                            <Button onClick={Proceed} className="bg-primary text-white"  >Let's Go!</Button>
                        </div>
                    </div>
                :
                <div>
                    <QuestionnaireQuestionBlock  questionnaires={questionnaire} handleAnswers={HandleChange} />
                    <div className="d-flex justify-content-between mb-3 mt-5">
                            
                        <Button onClick={HandleAnswerLater} disabled={isOnProcess}>Answer Later</Button>
                        <Button onClick={HandleConfirm} className="bg-primary text-white"  disabled={isOnProcess} >Submit</Button>
                    </div>
                </div>

            }
            
        </ModalBody>
    </Modal>
    )
}